import { render, staticRenderFns } from "./group_member.vue?vue&type=template&id=1cb91011&scoped=true&"
import script from "./group_member.vue?vue&type=script&lang=js&"
export * from "./group_member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb91011",
  null
  
)

export default component.exports